import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["footer"];

  DESKTOP_BREAKPOINT = 768;

  connect() {
    this.addEventListeners();

    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => this.toggleShadow.bind(this));
      this.resizeObserver.observe(this.element);
    }

    this.mutationObserver = new MutationObserver(() => this.toggleShadow.bind(this));
    this.mutationObserver.observe(this.element, {
      attributes: true,
      attributeFilter: ["class", "style"],
    });

    this.toggleShadow();
  }

  closeOnMobile() {
    if (window.innerWidth >= this.DESKTOP_BREAKPOINT) return;
    if (window.HSOverlay) window.HSOverlay.close(this.element);
  }

  addEventListeners() {
    this.element.addEventListener("scroll", this.toggleShadow.bind(this));
    window.addEventListener("resize", this.toggleShadow.bind(this));
    this.element.addEventListener("transitionend", this.toggleShadow.bind(this));
  }

  toggleShadow() {
    if (!this.hasFooterTarget) {
      return;
    }

    const isDesktop = window.innerWidth > this.DESKTOP_BREAKPOINT;
    if (isDesktop) {
      this.footerTarget.classList.remove("shadow-[0_4px_6px_10px_rgba(0,0,0,0.10)]");
      return;
    }

    const canScroll = this.element.scrollHeight > this.element.clientHeight;
    const atBottom =
      Math.abs(this.element.scrollHeight - this.element.scrollTop - this.element.clientHeight) <= 1;

    const shouldShowShadow = canScroll && !atBottom;

    this.footerTarget.classList.toggle(
      "shadow-[0_4px_6px_10px_rgba(0,0,0,0.10)]",
      shouldShowShadow
    );
  }
}
